import { Button } from 'primereact/button';
import * as React from 'react';
import { GroupServiceGetResponse } from '../../../services/api';
import { APIStatus } from '../../../utils/types';
import { Dialog } from 'primereact/dialog';
import ModalButtons from '../../ui/modals/ModalButtons';
import { unlockGroup } from '../../../store/group';
import FileUploader from '../../uploads/FileUploader';
import { InputTextarea } from 'primereact/inputtextarea';
import { Message } from 'primereact/message';

export default function HighRiskResponseForm({ group, onComplete }: { group: GroupServiceGetResponse, onComplete: () => void }) {
  const [isModalVisible, setIsModalVisible] = React.useState<boolean>(false);
  const [submissionState, setSubmissionState] = React.useState<APIStatus|null>(null);
  const [files, setFiles] = React.useState<File[]>([]);
  const [note, setNote] = React.useState<string>('');

  const formIsValid = React.useMemo<boolean>(() => {
    let isValid = true;

    if (!note.length) isValid = false;

    return isValid;
  }, [files, note]);

  async function handleFormSubmit() {
    try {
          setSubmissionState(APIStatus.LOADING);
    
          await unlockGroup({
            policyNumber: group.policyDetailModel?.policyNumber!,
            file: files[0],
            note,
          });

          onComplete();
          setSubmissionState(APIStatus.COMPLETE);
        } catch {
          setSubmissionState(APIStatus.ERROR);
        }
  }

  return (
    <div className="flex flex-col">
      <Button label="unlock group for rate relief" rounded icon="pi pi-lock-open" onClick={() => setIsModalVisible(true)} />

      <Dialog
        draggable={false}
        header={
          <>  
            <div>Unlock rate relief?</div>
            <p className="text-base font-normal">
              Provide relief if manageable and provide decision rationale for Account Management review with supporting documentation and notes..
            </p>
          </>
        }
        visible={isModalVisible}
        onHide={() => setIsModalVisible(false)}
        footer={
          <ModalButtons
            saveLabel="confirm and unlock group"
            isFormValid={formIsValid}
            isLoading={submissionState === APIStatus.LOADING}
            onCancel={() => setIsModalVisible(false)}
            onSave={handleFormSubmit}
          />
        }
      >
        <div className="flex flex-col gap-4">
        
          <div className="flex flex-col gap-2">
            <FileUploader files={files} onAddFile={(e) => setFiles(e)} />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="notes" className="font-bold">Supporting notes</label>
            <InputTextarea value={note} onChange={(e) => setNote(e.target.value)} id="notes" rows={5} placeholder="Add supporting notes" />
          </div>
        </div>

        {submissionState === APIStatus.ERROR && (
          <div className="flex flex-col mt-4">
            <Message severity="error" text="There was an error submitting your request, please try again" />
          </div>
        )}
      </Dialog>              
    </div>
  )
}